import { render, staticRenderFns } from "./TableFormatterCallback.vue?vue&type=template&id=a6bc62ba&"
import script from "./TableFormatterCallback.vue?vue&type=script&lang=js&"
export * from "./TableFormatterCallback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports